import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MegaMenuItem } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Observable } from 'rxjs';
import { AppUser, AuthService, EMPTY } from '../components/login.component';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent {
  @ViewChild('menuButton') menuButton!: ElementRef;

  @ViewChild('mobileMenuButton') mobileMenuButton!: ElementRef;

  @ViewChild('searchInput') searchInput!: ElementRef;

  /** GAP-UC-43: settings overlay opened from the topbar gear (REQ-002). */
  @ViewChild('uiPrefsOverlay') uiPrefsOverlay!: OverlayPanel;

  user$: Observable<AppUser | EMPTY>;

  constructor(
    public layoutService: LayoutService,
    public el: ElementRef,
    public authService: AuthService,
    public router: Router
  ) {
    this.user$ = this.authService.user$;
  }

  activeItem!: number;

  model: MegaMenuItem[] = [
    {
      label: 'UI KIT',
      items: [
        [
          {
            label: 'UI KIT 1',
            items: [
              {
                label: 'Form Layout',
                icon: 'pi pi-fw pi-id-card',
                routerLink: ['/uikit/formlayout']
              },
              {
                label: 'Input',
                icon: 'pi pi-fw pi-check-square',
                routerLink: ['/uikit/input']
              },
              {
                label: 'Float Label',
                icon: 'pi pi-fw pi-bookmark',
                routerLink: ['/uikit/floatlabel']
              },
              {
                label: 'Button',
                icon: 'pi pi-fw pi-mobile',
                routerLink: ['/uikit/button']
              },
              {
                label: 'File',
                icon: 'pi pi-fw pi-file',
                routerLink: ['/uikit/file']
              }
            ]
          }
        ],
        [
          {
            label: 'UI KIT 2',
            items: [
              {
                label: 'Table',
                icon: 'pi pi-fw pi-table',
                routerLink: ['/uikit/table']
              },
              {
                label: 'List',
                icon: 'pi pi-fw pi-list',
                routerLink: ['/uikit/list']
              },
              {
                label: 'Tree',
                icon: 'pi pi-fw pi-share-alt',
                routerLink: ['/uikit/tree']
              },
              {
                label: 'Panel',
                icon: 'pi pi-fw pi-tablet',
                routerLink: ['/uikit/panel']
              },
              {
                label: 'Chart',
                icon: 'pi pi-fw pi-chart-bar',
                routerLink: ['/uikit/charts']
              }
            ]
          }
        ],
        [
          {
            label: 'UI KIT 3',
            items: [
              {
                label: 'Overlay',
                icon: 'pi pi-fw pi-clone',
                routerLink: ['/uikit/overlay']
              },
              {
                label: 'Media',
                icon: 'pi pi-fw pi-image',
                routerLink: ['/uikit/media']
              },
              {
                label: 'Menu',
                icon: 'pi pi-fw pi-bars',
                routerLink: ['/uikit/menu']
              },
              {
                label: 'Message',
                icon: 'pi pi-fw pi-comment',
                routerLink: ['/uikit/message']
              },
              {
                label: 'Misc',
                icon: 'pi pi-fw pi-circle-off',
                routerLink: ['/uikit/misc']
              }
            ]
          }
        ]
      ]
    },
    {
      label: 'UTILITIES',
      items: [
        [
          {
            label: 'UTILITIES 1',
            items: [
              {
                label: 'Icons',
                icon: 'pi pi-fw pi-prime',
                routerLink: ['utilities/icons']
              },
              {
                label: 'PrimeFlex',
                icon: 'pi pi-fw pi-desktop',
                url: 'https://www.primefaces.org/primeflex/',
                target: '_blank'
              }
            ]
          }
        ]
      ]
    }
  ];

  get mobileTopbarActive(): boolean {
    return this.layoutService.state.topbarMenuActive;
  }

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  onRightMenuButtonClick() {
    this.layoutService.openRightSidebar();
  }

  onMobileTopbarMenuButtonClick() {
    this.layoutService.onTopbarMenuToggle();
  }

  focusSearchInput() {
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 0);
  }

  onOpenMojaInititucija() {
    this.router.navigate(['moja-institucija']);
  }

  /** GAP-UC-43: toggle the settings overlay from the gear (no navigation) (REQ-002). */
  onOpenUiPrefs(event: Event) {
    event.preventDefault();
    this.uiPrefsOverlay.toggle(event);
  }

  logout() {
    this.authService.logout();
  }

  navigate(route: string) {
    // ako stavimo u onClick onda se neće prikazati stil za link, kao za routerLink + href
    this.router.navigate([route]);
  }
}
